import { BaseService } from './BaseService';

class TableAPIService extends BaseService {
  public async getTables() {
    const route = `games/`;

    return this.get(route);
  }

  public async getTable(id: string) {
    const route = `games/${id}/`;

    return this.get(route);
  }
}

export const TableService = new TableAPIService();
